import { render, staticRenderFns } from "./quanxian.vue?vue&type=template&id=9a66b926&scoped=true"
import script from "./quanxian.vue?vue&type=script&lang=js"
export * from "./quanxian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a66b926",
  null
  
)

export default component.exports